import { StatusBadge } from '../../../shared/components/StatusBadge';

export interface ConsignmentStatusBadgeProps {
  status: string;
}

export function ConsignmentStatusBadge({ status }: ConsignmentStatusBadgeProps): JSX.Element {
  return <StatusBadge status={status} />;
}
